import moment from 'moment';

import qtiConstants from '../../../qti/Constants';
import loadingTools from '../loadingTools';

const { MOMENT_TIMEZONE } = qtiConstants.staticLibPaths;

const MomentTimezone = {
    getCoreFile() {
        return { url: `${MOMENT_TIMEZONE}moment-timezone-with-data.min.js`, type: 'js' };
    },

    getAllFilesToCache() {
        return [this.getCoreFile()];
    },

    async init() {
        if (window.moment === undefined) {
            window.moment = moment;
        }

        await loadingTools.loadLibrary(this.getCoreFile().url);
        return window.moment;
    },
};

export default MomentTimezone;
